/* eslint no-nested-ternary: 0 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import en from '../../../international/translations/en';
import config from '../../../config';
import { EditSettingsForm } from 'components';
import { resetState, updateUnit } from '../../../redux/Account/editSettings';


class EditSettings extends Component {

  static propTypes = {
    userSettings: PropTypes.object,
    editSettingsErrorMessage: PropTypes.string,
    editSettingsSuccessMessage: PropTypes.string,
    dispatch: PropTypes.func
  };

  constructor(props) {
    super(props);

    const { location } = this.props;
    this.redirectUrl = location.query && location.query.redirectUrl || null;
  }

  componentDidMount() {
    window.analytics.page('Account', 'Edit Settings');
  }

  componentWillUnmount() {
    this.props.dispatch(resetState());
  }

  onSettingChange = (fieldName, fieldValue) => {
    this.props.dispatch(updateUnit(fieldName, fieldValue));
    window.analytics.track(
      `Saved Unit`,
      { location: 'edit-settings', fieldName, fieldValue }
    );
  };

  render() {
    const {
      userSettings,
      editSettingsSuccessMessage,
      editSettingsErrorMessage
    } = this.props;

    return (
      <div className="editSettings">
        <Helmet title={en.edit_settings.meta_title[config.company]} />
        <div className="editSettings__heading__container">
          <div className="editSettings__heading">{en.edit_settings.title}</div>
        </div>
        <div className="editSettings__body__container">
          <div className="account__card">
            <EditSettingsForm
              userSettings={userSettings}
              onSettingChange={this.onSettingChange}
              editSettingsErrorMessage={editSettingsErrorMessage}
              editSettingsSuccessMessage={editSettingsSuccessMessage}
              redirectUrl={this.redirectUrl}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    userSettings: state.userSettings,
    editSettingsErrorMessage: state.userSettings.editSettingsErrorMessage,
    editSettingsSuccessMessage: state.userSettings.editSettingsSuccessMessage
  };
})(EditSettings);
